import { createStyles, makeStyles } from '@material-ui/core';

export const styles = makeStyles(() =>
  createStyles({
    button: {
      fontFamily: 'Sora',
    },
  }),
);
